import { ItemType } from '@vista-digital/ocapi-types/v1';
import { logger } from '../../../../utils/logger';
import { getItemById } from '../../selectors/items/get-item-by-id';
import { getLowestItemPrice, isDiscountItemPrice } from './item-price-utils';
/**
 * Determines whether a discounted price is available for a [[SellableItem]].
 *
 * @remarks
 * For a [[SellableItem]] representing a [[ParentSalesItem]], a discounted price is considered to be available
 * for the [[ParentSalesItem]] if any of its options have a discount.
 */
export const isDiscountedPriceAvailableForSellableItem = (sellableItem) => {
    const item = getItemById(sellableItem.itemId);
    if (!item) {
        logger.error(`Could not find item with ID: ${sellableItem.itemId}.`);
        return false;
    }
    switch (item.type) {
        case ItemType.Normal:
            return isLowestItemPriceDiscounted(sellableItem.prices);
        case ItemType.ParentSales:
            return item.options.some(option => isLowestItemPriceDiscounted(option.prices));
        default:
            return false;
    }
};
const isLowestItemPriceDiscounted = (prices) => {
    const lowestItemPrice = getLowestItemPrice(prices);
    return !!lowestItemPrice && isDiscountItemPrice(lowestItemPrice);
};
